import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Category, Product } from "@dashboard/modules/products/types/products.types";
import { OfferState, OfferWizardStep } from "../constants/offers.constants";
import { Offer, OfferDraft } from "../entities/offer.entity";
import { createEmptyDraft } from "../utils/validate-offer";
import { initialState } from "./offers.state";

const offersSlice = createSlice({
  name: "offers",
  initialState,
  reducers: {
    setUi: (
      state,
      { payload }: PayloadAction<Partial<typeof initialState.ui>>
    ) => {
      state.ui = { ...state.ui, ...payload };
    },
    setOffers: (state, { payload }: PayloadAction<Offer[]>) => {
      state.data.offers = payload;
    },
    setCatalogueProducts: (state, { payload }: PayloadAction<Product[]>) => {
      state.data.catalogueProducts = payload;
    },
    setCategories: (state, { payload }: PayloadAction<Category[]>) => {
      state.data.categories = payload;
    },
    setSelectedOffer: (
      state,
      { payload }: PayloadAction<Offer | undefined>
    ) => {
      state.data.selectedOffer = payload;
    },
    setDraftOffer: (state, { payload }: PayloadAction<Partial<OfferDraft>>) => {
      state.data.draftOffer = { ...state.data.draftOffer, ...payload };
    },
    resetDraftOffer: (state) => {
      state.data.draftOffer = createEmptyDraft();
      state.ui.wizardStep = OfferWizardStep.Selector;
    },
    loadDraftFromOffer: (state, { payload }: PayloadAction<Offer>) => {
      state.data.draftOffer = { ...payload };
      state.ui.wizardStep = OfferWizardStep.Selector;
    },
    updateOfferInList: (state, { payload }: PayloadAction<Offer>) => {
      const index = state.data.offers.findIndex((o) => o.id === payload.id);
      if (index !== -1) {
        state.data.offers[index] = payload;
      }
    },
    removeOfferFromList: (state, { payload }: PayloadAction<string>) => {
      state.data.offers = state.data.offers.filter((o) => o.id !== payload);
    },
    setSearchQuery: (state, { payload }: PayloadAction<string>) => {
      state.ui.searchQuery = payload;
    },
    toggleFilter: (state, { payload }: PayloadAction<OfferState>) => {
      const exists = state.ui.activeFilters.includes(payload);
      state.ui.activeFilters = exists
        ? state.ui.activeFilters.filter((f) => f !== payload)
        : [...state.ui.activeFilters, payload];
    },
    setWizardStep: (state, { payload }: PayloadAction<OfferWizardStep>) => {
      state.ui.wizardStep = payload;
    },
  },
});

export const offersActions = offersSlice.actions;
export default offersSlice.reducer;
